import React, { Fragment } from "react";
import { menuTranslations } from "../menu/i18n";
import { translations } from "../i18n";
import Axios from "axios";
import { getServiceName, getStage } from "../helper/domain";
const stage = getStage(window.location);
const trackingUrl = stage && `https://tracking.21re.${stage}/tracking/usage`;
const service = getServiceName(window.location);
const isFirefox = () => {
    const userAgent = window.navigator.userAgent;
    return userAgent.includes("Mozilla") || userAgent.includes("Firefox");
};
const trackUsageEvent = (url, eventName, companyId) => {
    if (trackingUrl && service) {
        const dataToPost = {
            event: eventName,
            additionalInfo: url,
            serviceName: service,
            companyId,
        };
        if (isFirefox()) {
            let request = new XMLHttpRequest();
            request.open("POST", trackingUrl, false);
            request.setRequestHeader("Content-Type", "application/json");
            request.withCredentials = true;
            request.send(JSON.stringify(dataToPost));
        }
        else {
            Axios.post(trackingUrl, dataToPost, { withCredentials: true });
        }
    }
};
export const RevoMainMenuFooterItem = (props) => {
    const menuTranslation = menuTranslations();
    const translate = translations();
    const isNotGerman = translate.languageCode !== "de";
    const urlLangSuffix = isNotGerman ? `?lang=${translate.languageCode}` : "";
    return (React.createElement("div", { className: "revoMainMenu__footerService" },
        React.createElement("div", { className: "revoMenuItem__text" }, props.name),
        React.createElement("ul", { className: "popup-menu" }, props.links.map((link, index) => {
            let key = link.key;
            let translation = menuTranslation.popupMenu[key];
            const lastItem = index === props.links.length - 1;
            const isServiceNotFeedback = props.name === "Service" && link.key !== "feedback";
            const target = isServiceNotFeedback ? "_blank" : "";
            const url = isServiceNotFeedback ? link.url + urlLangSuffix : link.url;
            const eventName = props.name === "Service" ? "MENU_SERVICE" : "MENU_USER";
            return (React.createElement(Fragment, { key: index },
                lastItem && (React.createElement("li", { className: "divider" },
                    React.createElement("hr", null))),
                React.createElement("li", null,
                    React.createElement("a", { className: link.className, onClick: () => {
                            props.companyId &&
                                trackUsageEvent(url, eventName, props.companyId);
                            return true;
                        }, target: target, href: url }, translation))));
        }))));
};
//# sourceMappingURL=revo-main-menu-footer-item.js.map